import styled from 'vue3-styled-components';

export const ModalContent = styled.div`
  background-color: #fff;
  border-radius: 16px; 
  width: 100%;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const Title = styled.h2`
  font-size: 25px;
  font-weight: bold;
  color: #cc5803;
  margin-bottom: 20px;
`;

export const TimeInfo = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  background-color: #f8f9fa;
  padding: 10px;
  border-radius: 12px;
  margin-bottom: 25px;
  width: 100%;
`;

export const TimeItem = styled.span`
  color: #555;
  font-size: 15px;
`;

export const TimeDivider = styled.span`
  color: #ddd;
`;

export const ContentWrapper = styled.div`
  width: 100%;
  max-width: 700px;
  margin: 20px;
`;

export const PhoneWrapper = styled.div`
  width: 100%;
  max-width: 700px;
  margin-bottom: 50px;
`;

export const InfoRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  width: 100%;
  justify-content: center;

  label {
    font-size: 17px;
    min-width: 80px;
    text-align: right;
    margin-right: 10px;
  }

  .value-box {
    background-color: #f8f9fa;
    padding: 8px 10px;
    border-radius: 8px;
    width: 120px;
    height: 20px;
    min-width: 120px;
    display: flex;
    align-items: center;
    color: #007bff;
    font-weight: 600;
    border: 1px solid #edf0f2;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
    transition: all 0.2s ease;

    &:hover {
      background-color: #fff;
      box-shadow: 0 3px 6px rgba(0, 0, 0, 0.05);
      transform: translateY(-1px);
    }
  }
    
  input {
    padding: 8px 10px;
    border-radius: 8px;
    height: 20px;
    width: 150px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
    font-size: 16px;
    
    &:hover {
      background-color: #fff;
      box-shadow: 0 3px 6px rgba(0, 0, 0, 0.05);
    }

    &:focus {
      background-color: #fff;
      border-color: #007bff;
      box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
    }
  }

  select {
    padding: 10px 12px;
    border-radius: 8px;
    border: 1px solid #ddd;
    color: #333;
    cursor: pointer;
    font-size: 16px;

    option {
      background-color: #fff;
      color: #333;
      padding: 8px;
    }
  }
`;

export const MessageContentContainer = styled.div`
  margin-bottom: 20px;
  width: 100%;
`;

export const MessageTextareaWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const ModernTextarea = styled.textarea`
  width: 100%;
  min-height: 120px;
  padding: 12px 15px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  line-height: 1.5;
  resize: vertical;
  transition: border-color 0.3s, box-shadow 0.3s;
  font-family: 'Noto Sans KR', sans-serif;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #4a90e2;
    box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.2);
  }

  &.over-limit {
    border-color: #e74c3c;
    box-shadow: 0 0 0 2px rgba(231, 76, 60, 0.2);
  }

  &::placeholder {
    color: #aaa;
  }
`;

export const ByteCounter = styled.div`
  position: absolute;
  bottom: 8px;
  right: 12px;
  font-size: 12px;
  color: #888;
  background-color: rgba(255, 255, 255, 0.8);
  padding: 2px 6px;
  border-radius: 4px;

  &.warning {
    color: #e74c3c;
    font-weight: bold;
  }
`;

export const MessageTemplates = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
`;

export const TemplateButton = styled.button`
  background-color: #f5f5f5;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: #e8f0fe;
    border-color: #4a90e2;
    color: #4a90e2;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  gap: 15px;
`;

const BaseButton = styled.button`
  padding: 12px 24px;
  border: none;
  border-radius: 12px;
  font-weight: 600;
  font-size: 0.95rem;
  cursor: pointer;
  color: white;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 140px;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  }

  &:active {
    transform: translateY(1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
`;

export const KakaoButton = styled(BaseButton)`
  background: #FFA500;
  
  &::before {
    margin-right: 8px;
    font-size: 1.1rem;
    font-weight: bold;
  }
`;

export const MessageButton = styled(BaseButton)`
  background:rgb(136, 17, 204);
  
  &::before {
    margin-right: 8px;
    font-size: 1.1rem;
    font-weight: bold;
  }
`;

export const AlimtalkButton = styled(BaseButton)`
  background: #2684FF;
  
  &::before {
    margin-right: 8px;
    font-size: 1.1rem;
    font-weight: bold;
  }
`;

export const BillButton = styled(BaseButton)`
  background: #00875A;
  
  &::before {
    margin-right: 8px;
    font-size: 1.1rem;
    font-weight: bold;
  }
`;

export const CloseButton = styled(BaseButton)`
  background: #666666;
  padding: 10px 20px;
  min-width: 100px;
  
  &::before {
    margin-right: 8px;
    font-size: 1.1rem;
  }
`;